import { api } from "@/lib/api";

export const pwaSupported = () => "serviceWorker" in navigator && "PushManager" in window;

export async function registerSW() {
  if (!("serviceWorker" in navigator)) return null;
  try { return await navigator.serviceWorker.register("/sw.js"); } catch { return null; }
}

const b64ToU8 = (s) => { const p = "=".repeat((4 - (s.length % 4)) % 4); const b = atob((s + p).replace(/-/g, "+").replace(/_/g, "/")); return Uint8Array.from([...b].map((c) => c.charCodeAt(0))); };

export async function enablePush() {
  const reg = (await navigator.serviceWorker.getRegistration()) || (await registerSW());
  if (!reg) throw new Error("Service worker unavailable");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notifications were blocked");
  const { data } = await api.get("/push/vapid");
  const sub = (await reg.pushManager.getSubscription()) || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToU8(data.publicKey) }));
  await api.post("/push/subscribe", { subscription: sub.toJSON() });
  return sub;
}

export async function disablePush() {
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg && (await reg.pushManager.getSubscription());
  if (sub) { await api.delete("/push/subscribe", { data: { endpoint: sub.endpoint } }); await sub.unsubscribe(); }
}

export async function pushEnabled() {
  if (!pwaSupported()) return false;
  const reg = await navigator.serviceWorker.getRegistration();
  return !!(reg && (await reg.pushManager.getSubscription()));
}
